import { render, staticRenderFns } from "./getHiredByStartup.vue?vue&type=template&id=1d59ae16&scoped=true&"
import script from "./getHiredByStartup.vue?vue&type=script&lang=js&"
export * from "./getHiredByStartup.vue?vue&type=script&lang=js&"
import style0 from "./getHiredByStartup.vue?vue&type=style&index=0&id=1d59ae16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d59ae16",
  null
  
)

export default component.exports